
const styles = {
  contentButton:{
    display:"flex",
    width:"100%",
    height:"69px",
    alignItems: "center",
    flexDirection: "row",
    paddingLeft:"20px",
  },
  buttonSalvar:{
    borderRadius:"25px",
    height: "40px",
  },
  styleDialog:{
    maxWidth:"100%",
    overflow:"hidden",
    maxHeight: '588px',
    height: '100%',
  },
  container:{
    width:"100%",
    height:"100%",
    overflowY:"scroll",
  },
  content:{
    display:"flex",
    flexDirection:"column",
    padding:"10px 20px",
    boxShadow:"10px 10px 25px rgba(112, 124, 151, 0.05), 15px 15px 35px rgba(112, 124, 151, 0.05) ",
    height:"100%",
    width:"500px",
  },
  wrapper:{
    display:"flex",
    flexDirection:"column",
  },
  wrapperModal:{
    display:"flex",
    flexDirection:"row"
  },
  modalTextMessage:{
    width:"572px !important",
    gap: '4px',
    display:"flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  title:{
    fontSize: "18px",
    fontWeight:"700",
  },
  envolved:{
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  fieldText:{
    marginTop: "4px",
  " &> div":{
    width:"100%",
    height:"325px"
  },
    " &>div>div":{
      width:"500px !important",
  },
  },
  label:{
    fontFamily: "Poppins !important",
    fontWeight: "bold",
  },
  contentInput:{
  display:"flex",
  flexDirection:"row",
  alignItems:"center",
  justifyContent:"space-between",
  color:"#505050",
  fontWeight:"400",
  paddingTop:"5px",
  gap:"10px",
  },
  inputName:{
    background:"#F2F2F2",
    border:"1px solid rgba(0, 0, 0, 0.1)",
    borderRadius:"8px",
    "&::placeholder": {
      fontSize: "14px",
    },
  },
  select:{
    display:"flex",
    flexDirection:"row",
    alignItems:"center",
    gap:"5px",
   },
  selectProfissional:{
    width:"230px",
    border:"1px solid rgba(0, 0, 0, 0.1)",
    borderRadius:"8px",
    background:"#f2f2f2",
    "& >div >div>div":{
    color:"#333333db",
    font:"inherit"
    }
  },
  header:{
    display:"flex",
    flexDirection:"row",
    justifyContent:"space-between",
    alignItems:"center",
  },
  contentAvisoPlugzapi:{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  wrapperAviso:{
    width: '500px',
    fontSize: '11px',
    fontWeight: '500',
    color: '#505050',
    display: 'flex',
    gap: '5px',
    alignItems:'center',
  },
  spanAviso:{
    fontSize:"11px !important"
  },
  contentIcon: {
    width: '21px',
    height: '20px',
    display: 'flex',
    borderRadius: '17px',
    justifyContent: 'center',
    background: '#F9BE73',
    alignContent: 'center',
    alignItems: 'center'
  },
  contentPopper:{
    background: "#fff",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    padding: "0 16px",
    borderRadius: "8px",
    maxWidth: 328,
  },
  popper:{
    "& > ol":{
      listStyle:"none",
      padding:0,
    }
  },
  nomeInput:{
    display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start'
  },
  selectTipoPadrao:{
    width: '125px',
    "& > div > div":{
      height: '34px',
      border:"1px solid rgba(0, 0, 0, 0.1)",
    }
  },
  contentSelect:{
    display: 'flex',
    height: '100%',
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'flex-start',
    flexDirection: 'column'  
  },
  contentSwitch:{
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignContent: 'space-between',
    height: '100%',
    alignItems: 'center'
  },
  switch:{
    height: '33px',
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'center',
    alignItems: 'center'
  },
  nomeTipo: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
  },
}
export default styles;